module.exports = __webpack_public_path__ + "img/magnifying_glass_icon.81be3647.svg";